import React, { useState } from "react";
import sheepImage1 from "../assets/images/Sheep/a6f6420093c8ca5b07705585c6ac4a493f84f1b3_1649485751.png";
import sheepImage2 from "../assets/images/Sheep/734cbfaa6bb8657fb853863c51e94c0803503b61_1649485559.png";
import sheepImage3 from "../assets/images/Sheep/5b5c6a10b98658eda77f83d47e00141b0f19ba48_1649486356.png";
import sheepImage4 from "../assets/images/Sheep/Image 1.png";
import sheepImage5 from "../assets/images/Sheep/Image 2.png";

import calfImage1 from "../assets/images/Calf/Image -1.png";
import calfImage2 from "../assets/images/Calf/Image -2.png";
import calfImage3 from "../assets/images/Calf/Image 5.png";

import chickenImage1 from "../assets/images/Chicken/Image 6.png";
import chickenImage2 from "../assets/images/Chicken/Image 7.png";
import chickenImage3 from "../assets/images/Chicken/Image 8.png";
import chickenImage4 from "../assets/images/Chicken/Image 9.png";
import chickenImage5 from "../assets/images/Chicken/Image 10.png";

import fishImage1 from "../assets/images/Fish/Image 11.png";
import fishImage2 from "../assets/images/Fish/Image 12.png";
import fishImage3 from "../assets/images/Fish/Image 13.png";
import fishImage4 from "../assets/images/Fish/حلوا-سفید-380x380.png";
import fishImage5 from "../assets/images/Fish/سنگسر-380x380.png";

import ShrimpImage1 from "../assets/images/Shrimp/میگو-خشک.png";
import ShrimpImage2 from "../assets/images/Shrimp/میگو-سایز-کامل-1.png";
import ShrimpImage3 from "../assets/images/Shrimp/میگو-91-110-کامل-1.png";

const SupplierContext = React.createContext({
  product: {
    id: "",
    title: "",
    cost: "",
    images: [{ value: "" }],
    limit: "",
    max: "",
    unit: "",
    options: {
      charkhkarde: true,
      khoreshti: true,
      kababi: true,
      sheshtike: true,
      pakshode: true
    },
    customerOrder: ""
  },
  sheep: {},
  calf: {},
  chicken: {},
  fish: {},
  shrimp: {},
  amazing: {},
  setProduct: state => {},
  setSheep: state => {},
  setCalf: state => {},
  setChicken: state => {},
  setFish: state => {},
  setShrimp: state => {},
  setAmazing: state => {}
});
export default SupplierContext;

export const SupplierContextProvider = ({ children }) => {
  const [product, setProduct] = useState();

  const [sheep, setSheep] = useState([
    // {
    //   id: 1,
    //   title: "گوشت خورشتی 2 کیلوگرم",
    //   minimumOrder: "نیم کیلو گرم",
    //   cost: 140000,
    //   images: [{ value: sheepImage1 }],
    //   limit: 1,
    //   max: 6,
    //   unit: "عدد",
    //   options: {
    //     charkhkarde: true,
    //     khoreshti: true,
    //     kababi: true,
    //     sheshtike: false,
    //     pakshode: false,
    //   },
    //   // options: [
    //   //   {
    //   //     value: {
    //   //       title: "چرخ کرده",
    //   //       cost: 120000,
    //   //       checked: true,
    //   //     },
    //   //     value: {
    //   //       title: "خورشتی",
    //   //       cost: 120000,
    //   //       checked: true,
    //   //     },
    //   //     value: {
    //   //       title: "کبابی",
    //   //       cost: 120000,
    //   //       checked: true,
    //   //     },
    //   //     value: {
    //   //       title: "شش تیکه",
    //   //       cost: 120000,
    //   //       checked: true,
    //   //     },
    //   //     value: {
    //   //       title: "پاک شده",
    //   //       cost: 120000,
    //   //       checked: true,
    //   //     },
    //   //   },
    //   // ],
    //   customerOrder: "",
    // },
  ]);
  const [calf, setCalf] = useState([
    // {
    //   id: 1,
    //   title: "ران و دست گوساله 2 کیلوگرم",
    //   minimumOrder: "نیم کیلو گرم",
    //   cost: 140000,
    //   images: [{ value: calfImage1 }, { value: calfImage1 }],
    //   limit: 1,
    //   max: 6,
    //   unit: "عدد",
    //   options: {
    //     charkhkarde: true,
    //     khoreshti: true,
    //     kababi: true,
    //     sheshtike: false,
    //     pakshode: false,
    //   },
    //   customerOrder: "",
    // },
  ]);
  const [chicken, setChicken] = useState([
    // {
    //   id: 1,
    //   title: "سینه بی استخوان 2 کیلوگرم",
    //   cost: 140000,
    //   images: [{ value: chickenImage1 }],
    //   minimumOrder: "نیم کیلو گرم",
    //   limit: 1,
    //   max: 6,
    //   unit: "عدد",
    //   finalCost: 160000,
    //   percent: 20,
    //   options: {
    //     charkhkarde: true,
    //     khoreshti: true,
    //     kababi: true,
    //     sheshtike: false,
    //     pakshode: false,
    //   },
    //   customerOrder: "",
    // },
  ]);
  const [fish, setFish] = useState([
    // {
    //   id: 1,
    //   title: "استیک ماهی شیر 2 کیلوگرم",
    //   minimumOrder: "نیم کیلو گرم",
    //   cost: 140000,
    //   images: [{ value: fishImage1 }],
    //   limit: 1,
    //   max: 6,
    //   unit: "عدد",
    //   options: {
    //     charkhkarde: true,
    //     khoreshti: true,
    //     kababi: true,
    //     sheshtike: false,
    //     pakshode: false,
    //   },
    //   customerOrder: "",
    // }
  ]);
  const [shrimp, setShrimp] = useState([
    // {
    //   id: 1,
    //   title: "میگو خشک 2 کیلوگرم",
    //   minimumOrder: "نیم کیلو گرم",
    //   cost: 140000,
    //   images: [{ value: ShrimpImage1 }],
    //   limit: 1,
    //   max: 6,
    //   unit: "عدد",
    //   options: {
    //     charkhkarde: true,
    //     khoreshti: true,
    //     kababi: true,
    //     sheshtike: false,
    //     pakshode: false,
    //   },
    //   customerOrder: "",
    // }
  ]);
  return (
    <SupplierContext.Provider
      value={{
        product,
        sheep,
        calf,
        chicken,
        fish,
        shrimp,
        setProduct,
        setSheep,
        setCalf,
        setChicken,
        setFish,
        setShrimp
      }}
    >
      {children}
    </SupplierContext.Provider>
  );
};
